/*=========================================================================================
  File Name: i18n.js
  Description: i18n configuration file. Imports i18n data.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import VueI18n from 'vue-i18n'
import i18nData from './attributes/i18nData.js'

Vue.use(VueI18n)
const lang = localStorage.getItem("language") ? localStorage.getItem("language") : 'vi-VN';
export default new VueI18n({
    locale: lang == 'vi-VN' ? 'vn' : 'en', // set default locale
    messages: i18nData
})
